// @ts-nocheck
import React, { memo } from "react";

import { type IconProps } from "antd/lib/icon";
import { Icon as AntdIcon } from "antd";

const Icon = (props: IconProps) => {
  return <AntdIcon {...props} />;
};

export default memo(Icon);
